import React from 'react'
import { NavLink } from 'react-router-dom';
import { categoriesMainDataHomeTeam } from '../../../data/data';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function HomeSectionTeamSlider() {
    // slider arrows is set custom style
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        draggable: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    };
    return (
        <div className='w-full  relative font-dropdownFont homeTeamSlider'>
            <Slider {...settings}>
                {
                    categoriesMainDataHomeTeam &&
                    categoriesMainDataHomeTeam.map((item, i) => (
                        <NavLink to="/" key={i}>
                            <div className="border-2 border-mainColor rounded-[0.313rem] mx-[0.625rem] font-semibold uppercase text-mainColor text-xs py-[5px] px-[15px] min-h-[4.688rem] flex   ">
                                <div className='line-three max-h-12 my-auto -tracking-tighter'>
                                    {item.name}
                                </div>
                            </div>
                        </NavLink>
                    ))
                }
            </Slider>
        </div >
    )
}
